import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Link, Redirect, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../../components/CustomPaginations";
import {
	tableStyle,
	dateCol,
	TrimString,
} from "../../../components/TableStyle";
import Header from "../../../components/Header";
import SelectCriteriaForm from "./SelectCriteriaForm";
import { CompensationLog_API } from "./CompensationLog_API";
import { Routes } from "../../../configurations/config";
import { GlobalPaginationSize } from "../../../components/GlobalPaginationSize";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function CompensationLog() {
	let token,
		joiningDate = null;
	let history = useHistory();

	const months = [
		{ value: 0, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];

	const date = new Date();
	const currentYear = date.getFullYear();
	const currentMonth = months[date.getMonth() + 1];
	const [pageNum, setPageNum] = useState(1);
	const [pagerData, setPagerData] = useState(null);
	const [yearsList, setYearsList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [compensationLogData, setCompensationLogData] = useState([]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.AdminPaginationSize
	);
	const [exportExcelDownloading, setExportExcelDownloading] = useState(false);
	const [selectedMonth, setSelectedMonth] = useState(
		sessionStorage.getItem("AdminCompensationLog")
			? JSON.parse(sessionStorage.getItem("AdminCompensationLog"))[0]
				? JSON.parse(sessionStorage.getItem("AdminCompensationLog"))[0]
				: currentMonth
			: currentMonth
	);
	const [selectedYear, setSelectedYear] = useState(
		sessionStorage.getItem("AdminCompensationLog")
			? JSON.parse(sessionStorage.getItem("AdminCompensationLog"))[1]
				? JSON.parse(sessionStorage.getItem("AdminCompensationLog"))[1]
				: {
						value: currentYear,
						label: currentYear,
				  }
			: {
					value: currentYear,
					label: currentYear,
			  }
	);

	const defaultSorted = [
		{
			dataField: "employeeName",
			order: "asc",
		},
	];
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const getColumns = [
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "compensation",
			text: "Compensations",
			sort: true,
		},
		{
			dataField: "type",
			text: "Type",
			sort: true,
			formatter: TrimString,
		},
		{
			dataField: "approvalDate",
			text: "Approval Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "requestDate",
			text: "Request Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "action",
			text: "Action",
			formatter: (cell, row) => {
				return (
					<div>
						<Link
							to={{
								pathname: `/adminRole/CompensationLogDetail/${row.requestId}`,
								state: { requestStatus: row.status },
							}}
						>
							<button className="btnStyle" title="View Detail">
								<FontAwesomeIcon
									id="edit"
									className="hoverEffect"
									icon={faEye}
									size="1x"
								/>
							</button>
						</Link>
					</div>
				);
			},
		},
	];
	useEffect(() => {
		//To auto start from joining date till current year
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate !== currentYear + 1);
		setYearsList(list);

		const header = { Authorization: `Bearer ${token}` };

		//get default Table pagination Data
		axios
			.get(
				`${CompensationLog_API.GetCompensationLogPagination}PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}&Month=${selectedMonth.value}&Year=${selectedYear.value}`,
				{
					headers: header,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setCompensationLogData(res.data.compensationLog);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
		setApiTokenHeader(header);
	}, []);

	const updateTableData = (month, year) => {
		setIsLoading(true);
		axios
			.get(
				`${CompensationLog_API.GetCompensationLogPagination}PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}&Month=${month}&Year=${year}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setCompensationLogData(res.data.compensationLog);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		axios
			.get(
				`${
					CompensationLog_API.GetCompensationLogPagination
				}PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}&Month=${selectedMonth.value}&Year=${
					selectedYear.value
				}`,
				{
					headers: apiTokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setCompensationLogData(res.data.compensationLog);
				}
			});
	};

	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//function called on table sorting and pginationn
		setIsLoading(true);
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			apiURL = `${CompensationLog_API.GetCompensationLogPagination}PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}&Month=${selectedMonth.value}&Year=${selectedYear.value}`;
			setSortBy([{ dataField: sortField, order: sortOrder }]);
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${CompensationLog_API.GetCompensationLogPagination}PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}&Month=${selectedMonth.value}&Year=${selectedYear.value}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: apiTokenHeader,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setCompensationLogData(res.data.compensationLog);
					}
				});
		}
	};
	const exportToExcel = () => {
		//function called on Export to Excel button
		setExportExcelDownloading(true);

		axios({
			url: `${CompensationLog_API.ExportToExcel}?Month=${selectedMonth.value}&year=${selectedYear.value}`,
			method: "GET",
			responseType: "blob",
			headers: apiTokenHeader,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "Compensation Log.xlsx");
				document.body.appendChild(link);
				link.click();
				setExportExcelDownloading(false);
			})
			.catch(() => {
				setExportExcelDownloading(false);
			});
	};

	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("AdminCompensationLog"))
			obj = JSON.parse(sessionStorage.getItem("AdminCompensationLog"));
		if (property === "month") obj[0] = value;
		else if (property === "year") obj[1] = value;
		sessionStorage.setItem("AdminCompensationLog", JSON.stringify(obj));
	};

	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `${Routes.AdminCompensationLogDetail}${row.requestId}`,
				state: { requestStatus: row.status },
			});
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				return userDetails.empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header title="Compensation Log" />
							<hr />

							{/*Filteration Form */}
							<SelectCriteriaForm
								months={months}
								selectedMonth={selectedMonth}
								onMonthChange={(value) => {
									setSelectedMonth(value);
									storeFiltersStates(value, "month");
									updateTableData(
										value.value,
										selectedYear.value
									);
								}}
								years={yearsList}
								selectedYear={selectedYear}
								onYearChange={(value) => {
									setSelectedYear(value);
									storeFiltersStates(value, "year");
									updateTableData(
										selectedMonth.value,
										value.value
									);
								}}
							/>

							{/*Button Container*/}
							<div className="d-flex justify-content-end my-2">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={exportExcelDownloading}
									disabled={
										!compensationLogData.length ||
										exportExcelDownloading
									}
								/>
							</div>

							{/*Table with Pagination Container*/}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"id"}
											columns={getColumns}
											items={compensationLogData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(
												pageNumber,
												PageSize
											) => {
												receiveData(PageSize);
											}}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection for unauthorized users
				);
			}}
		</UserConsumer>
	);
}

export default CompensationLog;
